// extracted by mini-css-extract-plugin
export default {"w-100":"styles_w-100__gFnud","loginChoice":"styles_loginChoice__2SR2-","loginButton":"styles_loginButton__Rwsve"};